/**
 * ── OS MODELOS DO CABEÇALHO DA ÁREA (bancada, leva S5) ───────────────────────
 *
 * O dono: «não vi onde configurar o menu que fica na barra superior acima do
 * herói: o que vai ali, formato… deveria ter configuração com modelos». Três
 * modelos, o tamanho da marca e se a barra fica fixa ao rolar. Sem import: o
 * aluno lê. `classico` é o cabeçalho de sempre — a compatibilidade.
 */
export const MODELOS_DE_CABECALHO = ['classico', 'centrado', 'minimo'] as const;
export type ModeloDeCabecalho = (typeof MODELOS_DE_CABECALHO)[number];

export const DESCRICAO_DO_MODELO: Record<ModeloDeCabecalho, { nome: string; frase: string }> = {
  classico: { nome: 'Clássico', frase: 'A marca à esquerda, os links e a conta à direita, numa linha. O de sempre.' },
  centrado: { nome: 'Centrado', frase: 'A marca no centro, sozinha; os links numa linha abaixo dela. Mais editorial.' },
  minimo: { nome: 'Mínimo', frase: 'Só a marca e um botão de menu: links e conta ficam na gaveta, em qualquer largura.' },
};

export const TAMANHOS_DA_MARCA = ['pequena', 'media', 'grande'] as const;
export type TamanhoDaMarca = (typeof TAMANHOS_DA_MARCA)[number];
/** A altura do logo (e o corpo do nome) em px. */
export const ALTURA_DA_MARCA: Record<TamanhoDaMarca, number> = { pequena: 20, media: 24, grande: 32 };

export interface CabecalhoResolvido {
  modelo: ModeloDeCabecalho;
  marca: TamanhoDaMarca;
  fixo: boolean;
}

/** Um corpo antigo (sem `cabecalho`) ou um valor desconhecido caem no clássico. */
export function cabecalhoResolvido(c: { modelo?: unknown; marca?: unknown; fixo?: unknown } | null | undefined): CabecalhoResolvido {
  const modelo = (MODELOS_DE_CABECALHO as readonly string[]).includes(String(c?.modelo)) ? (c!.modelo as ModeloDeCabecalho) : 'classico';
  const marca = (TAMANHOS_DA_MARCA as readonly string[]).includes(String(c?.marca)) ? (c!.marca as TamanhoDaMarca) : 'media';
  const fixo = typeof c?.fixo === 'boolean' ? c.fixo : true;
  return { modelo, marca, fixo };
}
